export default __webpack_public_path__ + "static/media/hildebrandt-logo.d663c16e.jpeg";